import React from 'react'
import './menuItem.css';
const MenuItem = function MenuItem(props) {
    return (
        <div   className={'ui-menuitem'}   onClick={props.onClick} >{props.children}</div>
    )
}

export { MenuItem };
